import React, {useEffect, useMemo, useState} from 'react';
import {useSelector} from "react-redux";
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";
import RenderComponents from "./RenderComponents";
import {generateBorder} from "../../Utils/generateStyles";
import {checkHidden} from "../../../../Utils/Form/FormDynamic/Utils/checkHidden";
import {getParamsFromString} from "../../Utils";
import {useCurrentResolution} from "../../../../Hooks/useCurrentResolution";
import {useResponsiveStyles} from "../../../../Hooks/useResponsiveStyles";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {multiLanguageValue} from "../../Utils/lib";
import {Tooltip} from "@material-ui/core";

const useStyles = makeStyles(() => {
    return {
        block: ({hoverStyles = {}}) => {
            const customStyles = hoverStyles.customStyles ? JSON.parse(hoverStyles.customStyles) : {};
            return {
                background: 'transparent',
                '&:hover': {
                    border: hoverStyles.border,
                    borderColor: hoverStyles.borderColor,
                    background: hoverStyles.background,
                    color: hoverStyles.color,
                    boxShadow: `${hoverStyles.boxShadow} ${hoverStyles.shadowColor}`,
                    ...customStyles
                }
            }
        }
    }
})
const BlockScreenComponent = ({element, basePath, containerArrayPath, actionsContext, doActions}) => {
    const [actions, setActions] = useState(null)
    const [blockUniqId, setBlockUniqId] = useState('')
    const {globalValues, screenName} = useSelector(state => state.jsonScreen);
    const {properties = {}, styles: sourceStyles} = element;
    const userLanguage = useSelector(state => state.app.userLanguage);
    const currentResolution = useCurrentResolution();
    const isHidden = checkHidden({...actionsContext, ...globalValues}, properties.hideCondition, screenName);
    const isActive = checkHidden({...actionsContext, ...globalValues}, properties.activeState, screenName);
    const styles = useResponsiveStyles(sourceStyles, currentResolution, isActive);
    const classes = useStyles({hoverStyles: styles.hoverStyles});
    const {appEnv} = useSelector(state => state.app)
    let borderObj = generateBorder(styles);

    const customStyles = useMemo(() => {
        const onLoad = (element.events || []).find(e => e.event === 'onLoad');
        if (onLoad) {
            const actions = onLoad.actions;
            const setStyles = (actions || []).find(e => e.type === 'setStyles');
            if (setStyles) {
                return getParamsFromString(setStyles.value, {...globalValues, ...actionsContext}, screenName);
            }
        }
        return {};
    }, [JSON.stringify(globalValues), screenName, JSON.stringify(actionsContext)])

    const backgroundImagePublicUrl = styles.backgroundImage ? process.env.NODE_ENV === 'development' ?
        `${process.env.REACT_APP_REMOTE_HOST}${appEnv}${styles.backgroundImage.url}` :
        `/${appEnv}` + styles.backgroundImage.url : '';
    const style = {
        width: styles.width,
        height: styles.height,
        maxWidth: styles.maxWidth === 'auto' ? styles.width : styles.maxWidth,
        boxShadow: `${styles.boxShadow} ${styles.shadowColor}`,
        margin: styles.margin,
        cursor: actions ? 'pointer' : 'auto',
        display: isHidden ? 'none' : 'block',
        borderRadius: isNaN(Number(styles.borderRadius)) ? styles.borderRadius : Number(styles.borderRadius),
        flexGrow: isNaN(Number(styles.flexGrow)) ? styles.flexGrow : Number(styles.flexGrow),
        ...customStyles,
        background: undefined,
        backgroundImage: `url(${backgroundImagePublicUrl})`,
        backgroundSize: 'cover',
    };

    const cardStyle = {
        height: '100%',
        width: '100%',
        padding: styles.padding,
        ...borderObj,
        borderRadius: isNaN(Number(styles.borderRadius)) ? styles.borderRadius : Number(styles.borderRadius),
        borderColor: styles.borderColor,
        borderStyle: styles.borderStyle || 'solid',
        background: customStyles.background ? customStyles.background  : styles.background,
        textAlign: styles.textAlign,
        minHeight: styles.minHeight,
        overflow: styles.overflow ? styles.overflow : 'auto',

    };
    const executedClassName = useMemo(() => {
        if(!styles.className) return "";
        return getParamsFromString(styles.className, {...globalValues, ...actionsContext}, screenName)
    }, [JSON.stringify(globalValues), screenName, JSON.stringify(actionsContext), styles.className])

    const multiLanguageTooltip = useMemo(() => {
        return multiLanguageValue(properties.tooltip, userLanguage)
    }, [userLanguage, properties.tooltip])


    useEffect(() => {
        if (element.events && element.events[0].event === 'onClick') {
            setActions(element.events[0].actions)
        }
    }, [])

    useEffect(() => {
        if (properties.elementId) {
            setBlockUniqId(getParamsFromString(properties.elementId, {...globalValues, ...actionsContext}, screenName))
        }
    }, [JSON.stringify(actionsContext), JSON.stringify(globalValues), properties.elementId, screenName])

    function onClick(e) {
        if (actions) {
            e.stopPropagation();
            doActions(actions, actionsContext);
        }
    }

    if (isHidden) return <></>
    return (
        <Tooltip title={multiLanguageTooltip}>
            <div style={style} onClick={onClick} className={executedClassName}>
                <div
                    id={blockUniqId}
                    className={classes.block}
                    style={{
                        ...cardStyle,
                        flexDirection: styles.flexDirection || 'column',
                        alignItems: styles.alignItems || 'baseline',
                        display: styles.display ? styles.display : 'flex',
                        gap: isNaN(Number(styles.gap)) ? styles.gap : Number(styles.gap),
                        justifyContent: styles.justifyContent
                    }}>
                    {(element.children || []).map(element => {
                        return (
                            <RenderComponents
                                key={element.id}
                                basePath={basePath}
                                element={element}
                                containerArrayPath={containerArrayPath}
                                actionsContext={actionsContext}
                            />
                        )
                    })}
                </div>
            </div>
        </Tooltip>
    );
};
export default JsonScreenHoc(BlockScreenComponent);